// extracted by mini-css-extract-plugin
export default {"preloader":"AuthPlaceholder_preloader__WvRdC","title":"AuthPlaceholder_title__88GHh","subtitle":"AuthPlaceholder_subtitle__ESGRd","img":"AuthPlaceholder_img__Sp3dy"};